import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import * as Sentry from "@sentry/vue";

const app = createApp(App)

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
});


app.use(VCalendar, {
    componentPrefix: 'vc',
})

app.mount('#app')
